import React from 'react';

export default function UserCell({ value }) {
  return <span>{value || ''}</span>;
}
